import * as React from "react";

const SubCatSvg = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
        viewBox="0 0 20 16"
    >
        <path
            d="M12 12h2v-2h2V8h-2V6h-2v2h-2v2h2zM2 16q-.824 0-1.412-.588A1.93 1.93 0 0 1 0 14V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h6l2 2h8q.824 0 1.413.587Q20 3.176 20 4v10q0 .825-.587 1.412A1.93 1.93 0 0 1 18 16zm0-2h16V4H9.175l-2-2H2z"
        ></path>
    </svg>
);

export default SubCatSvg;
